import React from 'react';
import { Typography, Card } from 'antd';
import IndividualInformHeader from '../components/individualInformHeader/individualInformHeader';
import IndividualSummary from '../components/individualSummary/individualSummary';
import IndividualGlobalResults from '../components/individualGlobalResults/individualGlobalResults';
import AutoSizeTitle from '../components/autoSizeTitle/AutoSizeTitle';

const { Title, Text } = Typography;

const PageResumeIndividual = ({ selectedEvaluation, totalResults, individualResult, pageNumber, orgLogo }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />
                <div className="internal-page-info internal-page-info-individual">
                    <IndividualInformHeader individualResult={individualResult} orgLogo={orgLogo}/>
                    <Card
                        style={{
                            borderRadius: '8px',
                            border: '1px solid #d9d9d9',
                            backgroundColor: '#fafafaff',
                            boxShadow: 'none',
                        }}
                        styles={{ body: { padding: '10px 24px' } }}
                    >
                        <IndividualSummary individualResult={individualResult} redLight={selectedEvaluation.evl_max_red_light} yellowLight={selectedEvaluation.evl_max_yellow_light} />
                    </Card>
                    <Card
                        style={{
                            borderRadius: '8px',
                            border: '1px solid #d9d9d9',
                            backgroundColor: '#fafafaff',
                            boxShadow: 'none',
                            marginTop: 16
                        }}
                        styles={{ body: { padding: '10px 24px' } }}
                    >
                        <IndividualGlobalResults individualResult={individualResult} totalResults={totalResults} />
                    </Card>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageResumeIndividual;
